import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { resolveUserTimezone } from '@/shared/utils/timezone'
import { formatDateTimeForUser } from '@/shared/utils/date'

export function useUserTimezone() {
  const { profile } = useAuth()
  const country = profile?.country || null

  const timezone = React.useMemo(
    () => resolveUserTimezone(country),
    [country],
  )

  return { timezone, country }
}

export function useUserDateFormatter() {
  const { timezone, country } = useUserTimezone()

  const formatUserDateTime = React.useCallback(
    (iso?: string | null) => formatDateTimeForUser(iso, timezone),
    [timezone],
  )

  return { formatUserDateTime, timezone, country }
}

